import axios from '@/libs/http'


/**
 * 查看会话列表
 */
export const getRoomList = ({ cursor, pageSize} = {}) => {
    return axios.request({
        url: '/s/c/chat-room/roomList',
        params: {
            cursor,
            pageSize,
        },
        method: 'get'
    })
}

/**
 * 查看会话列表
 */
export const getRoom = ({ roomId} = {}) => {
    return axios.request({
        url: '/s/c/chat-room/getRoom',
        params: {
            roomId,
        },
        method: 'get'
    })
}

//获取订单信息-（聊天页面）
export const getLatestOrderInfo = ({ userId } = {}) => {
    return axios.request({
        url: '/s/c/order/latestOrderInfo',
        params: {
            userId,
        },
        method: 'get'
    })
}


/**
 * 获取店员与用户之间的房间Id
 */
export const getRoomId = ({userId} = {}) => {
    return axios.request({
        url: '/s/c/chat-room/getRoomId',
        params: {
            userId,
        },
        method: 'get'
    })
}
/**
 * 创建房间
 */
export const createRoom = ({userId} = {}) => {
    let data = new URLSearchParams();
    data.append("userId",userId);
    return axios.request({
        url: '/s/c/chat-room/createRoom',
        data,
        method: 'post'
    })
}

/**
 * 查看在线用户列表
 */
export const listOnline = ({ cursor, pageSize} = {}) => {
    return axios.request({
        url: '/s/c/chat-room/listOnline',
        params: {
            cursor,
            pageSize,
        },
        method: 'get'
    })
}


/**
 * 修改置顶
 */
export const updateTop = (roomId, isTop) => {
    let data = new URLSearchParams();
    data.append("roomId", roomId);
    data.append("isTop", isTop);
    return axios.request({
        url: '/s/c/chat-room/updateTop',
        data,
        method: 'post'
    })
}
export const getChatAutoMessage = (type) => {
    return axios.request({
        url: '/s/c/copywriting/list',
        params: {
            type,
        },
        method: 'get'
    })
}
